import { productCardType } from '@/commonTypes';
import styles from './styles.module.css';
import RateComponent from '@/components/common/RateComponent';
import AppLink from '@/components/common/AppLink';
import MainIcons from '@/icons/main';
import PageCard from '@/components/general/PageCard';
import { avatarBg, lightBg, lightBgIcon } from '@/functions/formats';
import { getGroupedAttributes } from '@/functions/getGroupedAttributes';

type Props = {
  product?: productCardType;
};

export default function ProductInformation({ product }: Props) {
  const groupedAttributes = getGroupedAttributes(product);

  return (
    <div className={styles.wrapper}>
      {/* Brand */}
      <div className={styles.topRow}>
        <AppLink
          href={`/brands/${product?.brand?.slug}`}
          title={product?.brand?.brand}
          className={styles.brand}
        >
          {product?.brand?.brand}
        </AppLink>

        <span className={styles.sku}>کد کالا: {product?.sku}</span>
      </div>

      <h1 className={styles.title}>{product?.title}</h1>

      <div className={styles.ratingRow}>
        <div className={styles.rating}>
          <RateComponent rate={Number(product?.rate)} />

          <span className={styles.rate}>{product?.rate}</span>
        </div>

        <a href="#reviews" className={styles.reviewLink}>
          {product?.rateNumber} دیدگاه
        </a>

        <span className={styles.separator}>|</span>

        <span className={styles.sales}>{product?.soldCount}+ فروش موفق</span>

        <button className={styles.shareButton}>
          <MainIcons.shareIcon fill="var(--text-mut2)" />
          اشتراک‌گذاری
        </button>
      </div>

      {/* Shop */}

      <AppLink href={`/products?shop=${product?.shop?.slug}`}>
        <PageCard
          className={styles.shop}
          title={product?.shop?.title}
          icon={<MainIcons.shopIcon fill="var(--paper)" />}
          text={
            <div className={styles.shopMeta}>
              <span className={styles.shopRate}>
                <RateComponent rate={Number(product?.shop?.rate)} number={1} />

                {product?.shop?.rate}
              </span>

              <span>{product?.shop?.distance}</span>
            </div>
          }
          backgroundIcon={avatarBg(0)}
          aside={
            product?.shop?.featured && (
              <div className={styles.featuredSeller}>
                فروشندهٔ برگزیده
                <MainIcons.arrowIcon className={`rotateIcon-rtl`} />
              </div>
            )
          }
        />
      </AppLink>

      <div className={styles.sectionTitle}>ویژگی‌های کلیدی</div>

      <div className={styles.attributes}>
        {/* {product?.attributes?.map((attribute, index) => (
          <div
            key={attribute?.id ?? attribute?.slug ?? attribute?.title}
            className={styles.attribute}
          >
            <div className={styles.itemIcon} style={{ background: lightBg(index) }}>
              <MainIcons.notifIcon fill={lightBgIcon(index)} width="17px" height="17px" />
            </div>
            <div>
              <div className={styles.attributeTitle}>{attribute?.title}</div>

              <div className={styles.attributeValue}>
                {attribute?.options
                  ?.map((option) => option?.value)
                  .filter(Boolean)
                  .join('، ')}
              </div>
            </div>
          </div>
        ))} */}
        {groupedAttributes.map((attribute, index) => (
          <div key={attribute.attributeSlug} className={styles.attribute}>
            <div className={styles.itemIcon} style={{ background: lightBg(index) }}>
              <MainIcons.notifIcon fill={lightBgIcon(index)} width="17px" height="17px" />
            </div>

            <div>
              <div className={styles.attributeTitle}>{attribute.attributeName}</div>

              <div className={styles.attributeValue}>{attribute.values.join('، ')}</div>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.sectionTitle}>مدل خودرو سازگار</div>

      <div className={styles.cars}>
        {product?.compatibleCars?.map((car, index) => (
          <button
            key={car}
            className={`${styles.carButton} ${index === 0 ? styles.activeCar : ''}`}
          >
            {car}
          </button>
        ))}
      </div>
    </div>
  );
}
